<template>
  <div>
    <!-- 新增/编辑的对话框 -->
    <el-dialog :title="title" :visible="visible" width="40%" :modal-append-to-body="false" append-to-body
      @close="handleClose">
      <el-form class="baseForm" ref="form" :model="form" :rules="rules" label-width="120px">
        <el-form-item label="生成方式" prop="generateType">
          <el-radio-group v-model="form.generateType">
            <el-radio :disabled="optionType !== 'add'" :label="1">立即生成</el-radio>
            <el-radio :disabled="optionType !== 'add'" :label="2">实时生成</el-radio>
          </el-radio-group>
        </el-form-item>
        <!-- 数量 -->
        <el-form-item v-if="form.generateType === 1" label="数量" prop="generateNum">
          <el-input :disabled="optionType !== 'add'" v-model="form.generateNum" clearable maxlength="99" size="small"
            placeholder="请输入激活码数量"></el-input>
        </el-form-item>
        <!-- - 激活码商品 -->
        <el-form-item label="激活码商品" prop="cdkeyGoodsId">
          <el-select :disabled="optionType !== 'add'" @change="getGoodsDetail" v-model="form.cdkeyGoodsId"
            placeholder="请选择激活码商品" clearable size="small">
            <el-option v-for="item in activeGoodList.value" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <!-- 商品详情 -->
        <el-form-item v-if="form.cdkeyGoodsId" label="商品详情">
          <span>{{ goodsDetail }}</span>
        </el-form-item>
        <!-- 激活码过期时间 -->
        <el-form-item v-if="form.generateType === 1" label="激活码过期时间" prop="expireTime">
          <el-date-picker :disabled="optionType !== 'add'" v-model="form.expireTime" value-format="yyyy-MM-dd HH:mm:ss"
            type="datetime" clearable size="small" placeholder="选择时间"></el-date-picker>
        </el-form-item>
        <!-- 激活码有效期 -->
        <el-form-item v-if="form.generateType === 2" label="激活码有效期" prop="validDays">
          <el-input :disabled="optionType !== 'add'" v-model="form.validDays" clearable maxlength="99" size="small"
            placeholder="请输入激活码有效期"></el-input><span>&nbsp;天</span>
        </el-form-item>
        <!-- 业务类型 -->
        <el-form-item label="业务类型" prop="businessType">
          <el-select :disabled="optionType !== 'add'" v-model="form.businessType" placeholder="请选择业务类型" clearable
            size="small">
            <el-option v-for="item in businessTypeList.value" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <!-- 图片附件 -->
        <el-form-item label="图片附件" prop="img">
          <div class="flex">
            <el-upload :before-upload="checkUpload" :http-request="upload" listType="picture-img" :show-file-list="false">
              <el-button size="small" type="primary">点击上传文件</el-button>
            </el-upload>

            <div v-if="form.img" style="display: flex;">
              <el-image :preview-src-list="[form.img]" style="width: 100px; margin-right: 10px" :src="form.img"
                fit="scale-down"></el-image>
              <el-button type="text" icon="el-icon-remove" style="color: #ad1e1c" @click="delPic"></el-button>
            </div>
          </div>
        </el-form-item>
        <!-- 备注 -->
        <el-form-item label=" 备注" prop="descr">
          <el-input type="textarea" show-limit-word v-model="form.descr" clearable maxlength="9999" size="small"
            placeholder="请输入备注"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="hide">取 消</el-button>
        <el-button size="small" type="primary" @click="save"> 确 定 </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import axios from "axios";
import Message from '@/components/Message';
import { cloneDeep } from 'lodash'
import { addActiveCodeGenerate, editActiveCodeGenerate } from "@/api/memberNew/activeCodeGenerate"
import { addTrans, editTrans, getSalePeriodUnit } from "../../helper/index"
export default {
  inject: ["businessTypeList", "activeGoodList", "getList", "getActiveGoodsList"],
  name: "WebSaaSAdd",
  computed: {
    title() {
      return this.optionType === "add" ? "新增激活码生成" : "编辑激活码生成";
    },
  },
  data() {
    return {
      visible: false,
      /** 商品详情 */
      goodsDetail: null,
      /** 操作类型 */
      optionType: "add",
      /** 表单数据 */
      form: {
        /** 生成方式 */
        generateType: null,
        /** 激活码数量 */
        generateNum: "",
        /** 激活码商品 */
        cdkeyGoodsId: "",
        /** 过期时间 */
        expireTime: "",
        /** 有效期天数 */
        validDays: "",
        /** 业务类型 */
        businessType: "",
        /** 图片 */
        img: "",
        /** 图片名称 */
        goodsIconName: "",
        /** 备注 */
        descr: "",
      },
      /** 验证规则 */
      rules: {
        /** 生成方式 */
        generateType: [{ required: true, message: "请选择生成方式", trigger: "change" }],
        /** 激活码数量 */
        generateNum: [{ required: true, message: "请输入激活码数量", trigger: "blur" },
        { pattern: /^[1-9]\d*$/, message: "请输入正整数", trigger: "blur" }
        ],
        /** 激活码商品 */
        cdkeyGoodsId: [{ required: true, message: "请选择激活码商品", trigger: "change" }],
        /** 有效期天数 */
        validDays: [{ required: true, message: "请输入激活码有效期", trigger: "blur" },
        { pattern: /^[1-9]\d*$/, message: "请输入正整数", trigger: "blur" }
        ],
        /** 过期时间 */
        expireTime: [{ required: true, message: "请选择激活码过期时间", trigger: "change" }],
        /** 业务类型 */
        businessType: [{ required: true, message: "请选择业务类型", trigger: "change" }],
      },
    };
  },

  methods: {
    //^ ^--------------对话框内部-------------^ ^
    /** 选择商品 */
    getGoodsDetail(val) {
      console.log("选择商品", val);
      if (val) {
        const res = this.activeGoodList.value.find((item) => item.id == val);
        console.log('匹配到的商品', res);
        this.goodsDetail = res.name + ' ' + res.salePeriod + getSalePeriodUnit(res.salePeriodUnit) + ' ' + res.salePrice + '元'
      }

    },
    /** 删除图片 */
    delPic() {
      this.form.img = "";
      this.form.goodsIconName = "";
    },
    /** 上传图片校验 */
    checkUpload(file) {
      // 判断类型JPG 、 PNG
      if (!/image\/(png|jpg|jpeg)/.test(file.type)) {
        Message.error("只能上传jpg、png格式的图片");
        return false;
      }
      // 判断大小
      if (file.size > 1024 * 1024 * 5) {
        Message.error("不能上传超过5M的图片");
        return false;
      }
    },
    /** 上传图片的方法 */
    async upload(params) {
      console.log("上传图片的参数", params);
      const file = params.file;
      let formData = new FormData();
      formData.append("file", file);
      try {
        const { data } = await axios.post(
          "/lebo-resource/oss/endpoint/put-file?code=lebotob",
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );
        console.log("上传图片的响应", data);
        const result = data.data;
        if (data.code === 200) {
          /** 上传成功 */
          /** 赋值 */
          this.form.img = result.link;
          this.form.goodsIconName = params.file.name;
          /** 提示用户 */
          Message.success("上传成功");
        }
      } catch (error) {
        throw new Error(error);
      }
    },
    /** 保存 */
    save() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          console.log("表单数据", this.form);
          if (this.optionType === 'add') {
            this.add()
          } else {
            this.edit()
          }
          this.hide();
        }
      });
    },
    /** 新增数据 */
    async add() {
      console.log("新增的数据", this.form);
      const params = cloneDeep(this.form);
      const { data } = await addActiveCodeGenerate(addTrans(params));
      console.log("新增的响应", data);
      if (data.code === 200) {
        Message.success("新增成功");
        /** 通知刷新列表 */
        this.getList();
      }

    },
    /** 编辑数据 */
    async edit() {
      console.log("编辑的数据", this.form);
      const params = cloneDeep(this.form);
      const { data } = await editActiveCodeGenerate(editTrans(params));
      console.log("编辑的响应", data);
      if (data.code === 200) {
        Message.success("编辑成功");
        /** 通知刷新列表 */
        this.getList();
      }
    },
    //^ ^--------------对话框自身相关-------------^ ^
    show(row, optionType) {
      /** 打开对话框的时候重新拉取激活码商品数据 */
      this.getActiveGoodsList()
      if (row) {
        this.form = { ...row }
        this.getGoodsDetail(row.cdkeyGoodsId)
      }

      this.optionType = optionType || 'add'

      this.visible = true;
    },
    hide() {
      this.visible = false;
    },
    /** 关闭对话框 */
    handleClose() {
      /** 重置数据 */
      this.form = {
        /** 生成方式 */
        generateType: null,
        /** 激活码数量 */
        generateNum: "",
        /** 激活码商品 */
        cdkeyGoodsId: "",
        /** 过期时间 */
        expireTime: "",
        /** 有效期天数 */
        validDays: "",
        /** 业务类型 */
        businessType: "",
        /** 图片 */
        img: "",
        /** 图片名称 */
        goodsIconName: "",
        /** 备注 */
        descr: "",
      },
        this.goodsDetail = null
      /** 清除验证规则 */
      this.$nextTick(() => {
        this.$refs.form.clearValidate();
      });
      this.visible = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.baseForm {
  ::v-deep .el-input {
    width: 250px !important;
  }
}
</style>